import { inject, InjectionToken, Provider } from '@angular/core';

export interface MenuConfiguration {
	onMenuOpened?: () => void;
	onMenuClosed?: () => void;
}

export const defaultMenuConfiguration: MenuConfiguration = {};

export const MENU_CONFIGURATION = new InjectionToken<MenuConfiguration>('MENU_CONFIGURATION', {
	factory: () => defaultMenuConfiguration,
});

export const provideMenuConfiguration = (config: Partial<MenuConfiguration>): Provider => {
	return {
		provide: MENU_CONFIGURATION,
		useValue: {
			...defaultMenuConfiguration,
			...config,
		},
	};
};

export const injectMenuConfiguration = (): MenuConfiguration => {
	return inject(MENU_CONFIGURATION);
};
